import { useState, useCallback } from 'react';

const useToast = (timeout = 3000) => {
  const [toast, setToast] = useState({
    message: '',
    type: 'success',
    isVisible: false
  });

  const showToast = useCallback((message, type = 'success', callback) => {
    setToast({ message, type, isVisible: true });

    setTimeout(() => {
      setToast((prev) => ({ ...prev, isVisible: false }));
      if (callback && typeof callback === 'function') {
        callback();
      }
    }, timeout);
  }, [timeout]);

  const closeToast = () => {
    setToast((prev) => ({ ...prev, isVisible: false }));
  };

  return { toast, showToast, closeToast };
};

export default useToast;